export const docTabInitialValues = {
  expiresAt: '',
  month: '',
  uploadId: 0,
  terms: false,
  loadComment: '',
};

export const documentReviewModalInitialValues = {
  expiresAt: '',
  indefiniteTerm: false,
  revisionComment: '',
  isRejection: false,
  approved: false,
  checklist: [] as number[],
};
